import { render } from "./TermLinkForm.vue?vue&type=template&id=69676057&ts=true"
import script from "./TermLinkForm.vue?vue&type=script&lang=ts"
export * from "./TermLinkForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__